import { ChangeDeliveryAddressViewType } from '../types/view/ChangeDeliveryAddressViewType';

export const reflectValueToChangeDeliveryAddress = (
  changeDeliveryAddress: ChangeDeliveryAddressViewType,
  name: string,
  value: string
) => {
  switch (name) {
    case 'deliveryLastName':
      return {
        ...changeDeliveryAddress,
        deliveryLastName: value,
      };
    case 'deliveryFirstName':
      return {
        ...changeDeliveryAddress,
        deliveryFirstName: value,
      };
    case 'deliveryCountryCode':
      return {
        ...changeDeliveryAddress,
        deliveryCountryCode: value,
      };
    case 'deliveryZip':
      return {
        ...changeDeliveryAddress,
        deliveryZip: value,
      };
    case 'deliveryProvinceCode':
      return {
        ...changeDeliveryAddress,
        deliveryProvinceCode: value,
      };
    case 'deliveryCity':
      return {
        ...changeDeliveryAddress,
        deliveryCity: value,
      };
    case 'deliveryAddress1':
      return {
        ...changeDeliveryAddress,
        deliveryAddress1: value,
      };
    case 'deliveryAddress2':
      return {
        ...changeDeliveryAddress,
        deliveryAddress2: value,
      };
    case 'deliveryCompany':
      return {
        ...changeDeliveryAddress,
        deliveryCompany: value,
      };
    case 'deliveryPhone':
      return {
        ...changeDeliveryAddress,
        deliveryPhone: value,
      };
  }

  return changeDeliveryAddress;
};
